import myProfile from "./myProfile.json";
import header from "./header.json";
import changePassword from "./changePassword.json";
import common from "./common.json";
import sideBar from "./sideBar.json";
import footer from "./footer.json";
import transactions from "./transactions.json";
import betHistory from "./betHistory.json";
import lobby from "./lobby.json";
import game from "./game.json";
import payment from "./payment.json";
import bonus from "./bonus.json";
import verifyEmail from "./verifyEmail.json";
import referral from "./referral.json";
import home from "./home.json";
import sidebar from "./sb_leftsidebar.json";
import subheader from "./sb_subheader.json";
import rightsidebar from "./sb_rightsidebar.json";
import sb_home from "./sb_home.json";
import sb_market from "./sb_market.json";
import sportsevents from "./sb_sportsevents.json";
import supportModal from "./supportModal.json";
import schedule from "./sb_schedule.json";
import matchStatus from "./matchStatus.json";
import sb_extraMarketNames from "./sb_extraMarketNames.json";
import sb_mybets from "./sb_mybets.json";
import newSidebar from "./newSidebar.json";
import infoCard from "./infoCardHome.json";

const translationsEN = {
  ...myProfile,
  ...header,
  ...changePassword,
  ...common,
  ...sideBar,
  ...footer,
  ...transactions,
  ...betHistory,
  ...lobby,
  ...game,
  ...payment,
  ...bonus,
  ...verifyEmail,
  ...referral,
  ...home,
  ...sidebar,
  ...subheader,
  ...rightsidebar,
  ...sb_home,
  ...sb_market,
  ...sportsevents,
  ...supportModal,
  ...schedule,
  ...matchStatus,
  ...sb_extraMarketNames,
  ...sb_mybets,
  ...infoCard,
  ...newSidebar,
};

export default translationsEN;
